import BaseAPI from '@/apis/base/baseApi';

class EvidenceAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'evidence';
}

export default new EvidenceAPI();
